// extracted by mini-css-extract-plugin
module.exports = {"visible":"style_visible__mWNMX","invisible":"style_invisible__YQ5AI","container":"style_container__kNXG_","contentSkeletonContainer":"style_contentSkeletonContainer__1jT8f"};